import(/* webpackMode: "eager" */ "/vercel/path0/my-project/src/app/pricing/page.tsx");
